<script setup lang="ts">
const emit = defineEmits(['submit:prices'])

onMounted(() => {
  emit('submit:prices')
})
</script>

<template>
  <div class="absolute inset-0 my-12">
    <div class="bg-white absolute inset-0 opacity-50" />
    <div class="flex items-center justify-center h-full">
      <TLoader />
    </div>
  </div>
</template>
